import { render, staticRenderFns } from "./AdvanceReceiptDetail.vue?vue&type=template&id=19514636&scoped=true"
import script from "./AdvanceReceiptDetail.vue?vue&type=script&lang=js"
export * from "./AdvanceReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./AdvanceReceiptDetail.vue?vue&type=style&index=0&id=19514636&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19514636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19514636')) {
      api.createRecord('19514636', component.options)
    } else {
      api.reload('19514636', component.options)
    }
    module.hot.accept("./AdvanceReceiptDetail.vue?vue&type=template&id=19514636&scoped=true", function () {
      api.rerender('19514636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/advancereceipt/AdvanceReceiptDetail.vue"
export default component.exports